import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNavIconAllChannels = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 14 14",
	fill: "currentColor",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M9.177 4.79c-.59 0-1.071.495-1.071 1.104v6.632c0 .61.48 1.105 1.071 1.105h3.752c.59 0 1.071-.495 1.071-1.105V5.894c0-.61-.48-1.105-1.071-1.105zm1.34 7.46h1.072c.147 0 .268.124.268.276s-.12.276-.268.276h-1.072a.273.273 0 0 1-.268-.276c0-.152.12-.276.268-.276" }), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0 1.75C0 .988.624.368 1.392.368h9.743c.767 0 1.391.62 1.391 1.382v1.934h-1.392V1.75H1.392v4.835H7v4.836H3.48a.693.693 0 0 1-.696-.691c0-.382.31-.69.696-.69h1.507l.232-.692H1.392C.624 9.348 0 8.728 0 7.967zm12.526 3.04h-1.392v1.795H8.105v2.763h3.03c.767 0 1.391-.62 1.391-1.381zm-4.42 5.25h.94c.386 0 .697.308.697.69s-.311.69-.696.69h-.942z"
	})]
});
export default SvgNavIconAllChannels;
